<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class="chart">
        <div id="chart-div" class="chart-div">
          <DxToolbar>
            <DxItem
              #default
              location="before"
              locate-in-menu="never"
            >
              <div class="toolbar-label"><b>년도 : </b></div>
            </DxItem>
            <DxItem
              :options="selectBoxYearOptions"
              location="before"
              locate-in-menu="auto"
              widget="dxSelectBox"
            />
            </DxToolbar>
            <DxChart
              id="chart"
              :data-source="productChart"
              palette="Office"
              title="불량손실재료비"
              class="DxChart"
            >
              <DxCommonSeriesSettings
                type="bar"
                argument-field="발생월"
              />
              <DxSeries
                v-for="cause in listOfCauses"
                :key="cause.value"
                :value-field="cause.value"
                :name="cause.value"
              />
              <DxCommonAxisSettings>
                <DxGrid :visible="true"/>
              </DxCommonAxisSettings>
              <DxValueAxis
                name="amount"
                position="left"
              />
              <DxMargin :bottom="20"/>
              <DxArgumentAxis
                :allow-decimals="false"
                :axis-division-factor="30"
              >
                <DxLabel>
                  <DxFormat type="decimal"/>
                </DxLabel>
              </DxArgumentAxis>
              <DxLegend
                :visible="false"
                vertical-alignment="right"
              />
              <DxExport
                :enabled="true"
                title="연 불량현황"
                />
              <DxTooltip
                :enabled="true"
                :shared="true"
              />
              <DxSize :height="screenHeight * 0.5"/>
            </DxChart>
          </div>
      </div>
      <div>
        <DxPivotGrid
          ref="refPivot"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :show-borders="true"
          :show-column-grand-totals="false"
          :show-row-grand-totals="false"
          :show-row-totals="false"
          :show-column-totals="true"
          :data-source="dataSource"
          @cell-prepared = 'onCellPrepared'
          @exporting="onExporting"
        >
          <DxFieldChooser
            :enabled="false"
            :height="350"
          />
          <DxExport
            :enabled="true"
            :file-name="excelTitle"
          />
        </DxPivotGrid>
      </div>
      <div class="pie-wrap">
        <div class="toolbar-div" style="">
            <DxToolbar class='select-group'>
              <DxItem
                #default
                location="before"
                locate-in-menu="never"
              >
                <div class="toolbar-label"><b>년도 : </b></div>
              </DxItem>
              <DxItem
                :options="pieSelectBoxYearOptions"
                location="before"
                locate-in-menu="auto"
                widget="dxSelectBox"
              />
                <DxItem
                #default
                location="before"
                locate-in-menu="never"
              >
                <div class="toolbar-label"><b>월 : </b></div>
              </DxItem>
              <DxItem
                :options="pieSelectBoxMonthOptions"
                location="before"
                locate-in-menu="auto"
                widget="dxSelectBox"
              />
            </DxToolbar>
        </div>
        <div class="pie-div">
          <div class="pie-child-div">
            <DxPieChart
              id="pie"
              :data-source="pieChartMonthData"
              class="pie-chart"
              palette="Office"
              title="월 불량비율"
              type="doughnut"
            >
              <DxPieSeries
                argument-field="코드명"
                value-field="불량수량"
              >
                <DxPieLabel :visible="true" :customize-text="formatLabel">
                  <DxPieConnector
                    :visible="true"
                    :width="1"
                  />
                </DxPieLabel>
              </DxPieSeries>
              <DxTooltip
                :enabled="false"
              />
              <DxPieSize :height="screenHeight * 0.5"/>
              <DxPieExport :enabled="true"/>
            </DxPieChart>
          </div>
          <div class="pie-child-div">
            <DxPieChart
              id="pie"
              :data-source="pieChartYearData"
              class="pie-chart"
              palette="Office"
              title="연 불량비율"
              type="doughnut"
            >
              <DxPieSeries
                argument-field="코드명"
                value-field="불량수량"
              >
                <DxPieLabel :visible="true" :customize-text="formatLabel">
                  <DxPieConnector
                    :visible="true"
                    :width="1"
                  />
                </DxPieLabel>
              </DxPieSeries>
              <DxPieSize :height="screenHeight * 0.5"/>
              <DxPieExport :enabled="true"/>
              <DxTooltip
                :enabled="false"
              />
            </DxPieChart>
          </div>
        </div>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import axios from 'axios'
import DxPieChart, {
  DxSize as DxPieSize,
  DxSeries as DxPieSeries,
  DxLabel as DxPieLabel,
  DxConnector as DxPieConnector,
  DxExport as DxPieExport
} from 'devextreme-vue/pie-chart'
import {
  DxChart,
  DxSeries,
  DxValueAxis,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxCommonAxisSettings,
  DxGrid,
  DxSize,
  DxExport,
  DxLegend,
  DxMargin,
  DxTooltip,
  DxLabel,
  DxFormat
} from 'devextreme-vue/chart'
import { DxPivotGrid, DxFieldChooser
} from 'devextreme-vue/pivot-grid'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
// excel export 관련 lib
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportPivotGrid } from 'devextreme/excel_exporter'
export default {
  name: 'ProductChart',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      screenHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '연 불량현황'
        }
      ],
      productChart: [],
      pieChartYearData: [],
      pieChartMonthData: [],
      selectBoxYearOptions: null, // chart 및 Pivot 사용됨
      selectBoxMonthOptions: null, // chart 및 Pivot 사용됨
      thisYear: null, // chart 및 Pivot 사용됨
      selectedMonth: null,
      pieSelectBoxYearOptions: null, // pie 사용
      pieSelectBoxMonthOptions: null, // pie 사용
      pieThisYear: null, // chart 및 Pivot 사용됨
      pieSelectedMonth: null,
      monthlyData: [],
      dataSource: null,
      excelTitle: null,
      pivotGirdData: [], // PieChart 와 같이쓰임
      resultSum: null,
      planSum: null,
      listOfCauses: [{ value: '손실액' }], // Series 생성을 위한 변수
      chartWidth: null,
      totalTime: null, // PieChart % 비율계산을 위한 변수
      pieWidth: 400
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxChart,
    DxValueAxis,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxCommonAxisSettings,
    DxGrid,
    DxExport,
    DxSize,
    DxLegend,
    DxMargin,
    DxTooltip,
    DxLabel,
    DxFormat,
    DxToolbar,
    DxItem,
    DxPivotGrid,
    DxFieldChooser,
    // pie
    DxPieChart,
    DxPieSize,
    DxPieSeries,
    DxPieLabel,
    DxPieConnector,
    DxPieExport
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.init()
    this.pieInit()
    this.handleResize()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  updated () {
  },
  beforeDestroy: function () {
  },
  methods: {
    handleResize (e) {
      console.log(screen.height)
      this.screenHeight = (screen.height - 520)
    },
    /* ==============START EXCEL EXPORT============ */
    onExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.excelTitle)
      exportPivotGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ pivotCell, excelCell }) => {
          if (excelCell._value.model.value === 0) {
            excelCell._value.model.value = ''
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.excelTitle}.xlsx`)
        })
      })
      e.cancel = true
    },
    /* ==============END EXCEL EXPORT============ */
    customizeTooltipPie () {
      return ''
    },
    customizeTooltip () {
      return ''
    },
    formatLabel (qty) {
      return `${qty.percentText}`
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.thisYear = args.value
          this.refreshPivotGrid(this.thisYear, this.selectedMonth)
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      // makeMonth 할때 사용
      this.selectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.selectedMonth,
        onValueChanged: (args) => {
          this.selectedMonth = args.value
          this.refreshPivotGrid(this.thisYear, this.selectedMonth)
        }
      }
      this.saveBadProductCostByMonth(this.thisYear, this.selectedMonth)
    },
    pieInit () {
      this.pieThisYear = AppLib.getThisYear()
      this.pieSelectedMonth = AppLib.getThisMonth()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.pieSelectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.pieThisYear,
        onValueChanged: (args) => {
          this.pieThisYear = args.value
          this.refreshPieChart(this.pieThisYear, this.pieSelectedMonth, 'year')
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      this.pieSelectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.pieSelectedMonth,
        onValueChanged: (args) => {
          this.pieSelectedMonth = args.value
          this.refreshPieChart(this.pieThisYear, this.pieSelectedMonth, 'month')
        }
      }
      this.refreshPieChart(this.pieThisYear, this.pieSelectedMonth, 'year')
    },
    onToolbarPreparing (e) {
      //
    },
    onCellPrepared (e) {
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        } else {
          // this.$Q(e.cellElement).find('span').text(this.calculateDowntime(e.cell.value))
        }
      }
    },
    refreshPieChart (year, month, searchType) {
      const monthParam = { fromDate: `${year}-${month}-01`, toDate: `${year}-${month}-${AppLib.getMonthLastDay(year, month)} 23:59:59` }
      const yearParam = { fromDate: `${year}-01-01`, toDate: `${year}-12-31 23:59:59` }
      const array = []
      array.push(this.$_sp.runNoEncodeFindProc('spFindAll불량수불ByDate', monthParam))
      if (searchType === 'year') {
        array.push(this.$_sp.runNoEncodeFindProc('spFindAll불량수불ByDate', yearParam))
      }
      axios.all(array)
        .then(axios.spread((...reponse) => {
          this.pieChartMonthData = this.$_sp.MakeModel(reponse[0])
          // this.calcRate(this.pieChartMonthData)
          if (searchType === 'year') {
            this.pieChartYearData = this.$_sp.MakeModel(reponse[1])
            // this.calcRate(this.pieChartYearData)
          }
        })
        )
    },
    refreshPivotGrid (year, month) {
      this.excelTitle = `${year}년 불량현황`
      const param = { fromDate: `${year}-01-01`, toDate: `${year}-12-31 23:59:59` }
      this.$_sp.runNoEncodeFindProc('spFindAll불량품월손실ByDate', param)
        .then((data) => {
          this.pivotGirdData = this.$_sp.MakeModel(data)
          if (this.pivotGirdData.length > 0) {
            this.makeMonthly(this.pivotGirdData)
            this.setInitDataSource()
            this.makeChartData()
          } else {
            this.pivotGirdData = []
            this.productChart = []
            this.dataSource = []
          }
        })
    },
    async saveBadProductCostByMonth (year, month) {
      let thisYear = AppLib.getThisYear()
      let thisMonth = AppLib.getThisMonth()
      const param = { 기준일: `${thisYear}-${thisMonth}-01` }
      await this.$_sp.runNoEncodeFindProc('spSaveBadProductCostByMonth', param)
        .then((data) => {
          this.refreshPivotGrid(year, month)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    makeChartData () {
      this.productChart = []
      let timeStamp
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        this.productChart.push({ 발생월: `${timeStamp.split('-')[1]}월` })
        let where = this.$_.findWhere(this.pivotGirdData, { 발생월: timeStamp, 그룹: '금액' })
        if (where !== undefined && where.data > 0 && where.그룹 === '금액') {
          const temp = {
            발생월: `${timeStamp.split('-')[1]}월`,
            손실액: where.data
          }
          this.productChart.push(temp)
        }
      }
    },
    makeMonthly (pivotGirdData) {
      let timeStamp
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        let where = this.$_.findWhere(pivotGirdData, { 발생월: timeStamp, 그룹: '금액' })
        if (where === undefined) {
          const temp = {
            발생월: timeStamp,
            그룹: '금액'
          }
          pivotGirdData.push(temp)
        }
      }
    },
    calcRate (list) {
      // 불량수량 -> 비율 계산로직
      let 총불량수량 = (list).reduce((s, f) => s + f.불량수량, 0)
      for (let i in list) {
        list[i].불량수량 = (list[i].불량수량 / 총불량수량)
      }
    },
    setInitDataSource () {
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '그룹',
            dataField: '그룹',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            dataField: '발생월',
            dataType: 'date',
            area: 'column',
            groupInterval: 'year',
            expanded: true
          },
          {
            dataField: '발생월',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            caption: '',
            dataField: 'data',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }
        ],
        store: this.pivotGirdData
      })
    }
  }
}
</script>

<style lang="scss">
.pie-div{
  display: flex;
}
.pie-div>.pie-child-div{
  margin: 0 auto;
}
.toolbar-div{
  margin-top: 10px;
  display: block;
}
.pie-wrap {
  margin-top: 10px;
  padding: 0 10px;
  border-radius: 10px;
  border: 1px solid rgb(179, 179, 179);
}
</style>
